import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-white py-8 px-4 text-center" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <div className="border-t border-gray-800 pt-6 text-xs text-gray-500" data-id="element-53">
          <p className="mb-1" data-id="element-54">
            © 2026 El Asombroso Viaje por el Cuerpo Humano
          </p>
          <p data-id="element-55">
            Todos los derechos reservados. Privacidad · Términos y Condiciones
          </p>
        </div>
      </div>
    </footer>;
}